import * as Yup from 'yup';

export const validationSchema = Yup.object().shape({
  content: Yup.string().required('sendEmailModal.errors.content'),
  subject: Yup.string().required('sendEmailModal.errors.subject'),
});
